import { cn } from "@newxsystems/shared";
import { getBalancedGridColumnCount } from "@templates/design-system";
import { getComponent } from "../../../../client";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import type { ILogoCloudGridProps } from "./LogoCloudGrid.props";

const desktopColumns = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
} as const;

export const LogoCloudGrid = ({ items }: ILogoCloudGridProps) => {
  const Link = getComponent("Link");
  const desktopColumnCount = getBalancedGridColumnCount(items.length);
  return (
    <div
      className={cn(
        "grid items-stretch gap-4 py-4",
        items.length === 1 ? "grid-cols-1" : "grid-cols-2",
        desktopColumns[desktopColumnCount],
      )}
    >
      {items.map((item, index) => {
        const logo = (
          <WohaMedia
            className="h-20 w-full rounded-xl border border-ash bg-white p-5"
            imageClassName="object-contain grayscale transition-[filter] duration-200 group-hover:grayscale-0"
            media={item.logo}
            sizes="160px"
          />
        );
        return (
          <div className="h-full w-full" key={index}>
            {item.logoLink ? (
              <Link
                aria-label={item.logoLink.accessibilityLabel || undefined}
                className="group block rounded-xl focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-blue"
                href={item.logoLink.href}
                rel={item.logoLink.openInNewTab ? "noopener noreferrer" : undefined}
                target={item.logoLink.openInNewTab ? "_blank" : undefined}
              >
                {logo}
              </Link>
            ) : (
              logo
            )}
          </div>
        );
      })}
    </div>
  );
};
LogoCloudGrid.displayName = "Content::LogoCloudGrid";
